<template>
    <nav class="w-full" @mouseenter="mouseWithinMenu=true" @mousemove="mouseWithinMenu=true" @mouseleave="mouseLeave($event)">
        <div class="bg-gradient-to-r from-[#213853] to-[#2c4a6b] shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1),0_2px_4px_-2px_rgba(0,0,0,0.1),inset_0_6px_6px_-6px_rgba(0,0,0,0.3)] border-b border-gray-900/25">
        <!-- <div class="bg-gradient-to-t from-[#2c4a6b] to-[#001e36] shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1),0_2px_4px_-2px_rgba(0,0,0,0.1),inset_0_6px_6px_-6px_rgba(0,0,0,0.3)] border-b border-gray-900/25"> -->
        <!-- <div class="bg-gradient-to-t from-[#1a2c42] to-[#2c4a6b] shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1),0_2px_4px_-2px_rgba(0,0,0,0.1),inset_0_6px_6px_-6px_rgba(0,0,0,0.3)] border-b border-gray-900/25"> -->
            <div class="w-full max-w-8xl mx-auto main-menu flex items-center justify-center xl:justify-start">
                <div v-if="items.length > 0">
                    <ul class="list-none p-0">
                        <li class="dropdown" v-for="item in items">
                            <a class="dropbtn"
                                :class="{'active text-tan-400': isActive(item)}"
                                @mouse-over="changeActive(item)"
                                :key="item.name"
                                :href="getLink(item)"
                            >
                                {{ item.label }}
                                <svg v-if="hasSubLinks(item)" class="block float-right fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                            </a>
                            <div class="dropdown-content" v-if="hasSubLinks(item)">
                                <span v-for="subitem in item['sub-links']" :key="subitem.label">
                                    <hr v-if="subitem.separator" class="w-full h-px m-0 bg-blue-200 border-t-1-px opacity-25" />
                                    <a v-else
                                        v-if="!isAdminOnly(subitem)"
                                        :class="{'sub-active': isCurrentRoute(subitem)}"
                                        :href="getLink(subitem)"
                                        >
                                            {{ subitem.label }}
                                    </a>
                                </span>
                            </div>
                        </li>
                    </ul>
                    <slot name="phone-number"></slot>
                </div>
                <div v-else>
                    <div class="md:hidden border-b-2 border-blue-600 m-0 p-0"></div>
                    <div class="md:hidden border-b border-blue-500 m-0 p-0"></div>
                    <div class="xs:hidden sm:hidden md:flex md:h-8"></div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    items: {
        type: Array,
        required: true
    },
});

// let urlParams = new URLSearchParams(window.location.search);
let currentPrefix = (window.route().current() && window.route().current().split('.')[0]) || null;

const currentRoute = ref(window.route().current());
const active = ref(null);
const mouseWithinMenu = ref(false);

const hasSubLinks = (item) => (typeof item['sub-links'] !== 'undefined' && item['sub-links'].length > 0);

const getLink = (item) => {
    if (!hasSubLinks(item)) {
        if (item.parameter) {
            return window.route(item.link, item.parameter).toString();
        } else {
            return window.route(item.link).toString();
        }
    }
    return 'javascript:';
};

const changeActive = (item) => {
    active.value = item;
};

const isAdminOnly = (item) => {
    if (item.adminOnly && [2, 4, 6, 16, 22].indexOf(window.currentUser?.id) === -1) {
        return true;
    }
    return false;
};

const isActive = (item) => {
    return (item === active?.value || item.prefix === currentPrefix?.value || item['sub-links']?.some(subLink => subLink.prefix === currentPrefix?.value));
};

const isCurrentRoute = (item) => {
    if (item.parameter) {
        const param = Object.keys(item.parameter)[0];
        const paramValue = item.parameter[param];
        const pathSegments = window.location.pathname.split('/').filter(segment => segment.trim() !== '');
        return pathSegments[1] === paramValue;
        // return urlParams.get(param) === paramValue;
    }
    return item.link === currentRoute.value;
};

const findActive = () => {
    return props.items.find((item) => {
        if (isCurrentRoute(item)) {
            return item;
        }
        if (hasSubLinks(item)) {
            return item['sub-links'].find((subItem) => isCurrentRoute(subItem));
        }
    });
};

const mouseLeave = (e) => {
    mouseWithinMenu.value = false;
    if (!mouseWithinMenu.value) {
        active.value = findActive();
    }
};

function updateParentActiveClass() {
    // Select all parent menu items
    const menuItems = document.querySelectorAll('.dropdown');
    menuItems.forEach(item => {
        const hasActiveChild = item.querySelector('.dropdown-content span a.sub-active') !== null;
        if (hasActiveChild) {
            item.querySelector('.dropbtn').classList.add('active');
        } else {
            item.querySelector('.dropbtn').classList.remove('active');
        }
    });
}

onMounted(() => {
    active.value = findActive();
    updateParentActiveClass();
});
</script>
